import { render, staticRenderFns } from "./cg-event-teaser-quicklinks.vue?vue&type=template&id=7c87b9a5&scoped=true"
import script from "./cg-event-teaser-quicklinks.vue?vue&type=script&lang=js"
export * from "./cg-event-teaser-quicklinks.vue?vue&type=script&lang=js"
import style0 from "./cg-event-teaser-quicklinks.vue?vue&type=style&index=0&id=7c87b9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87b9a5",
  null
  
)

export default component.exports